import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CaseManager } from '../../../../managers/case.manager';
import { LexbeCase } from '../../../../models/case.model';
import { BaseComponent } from '../../../base.component';

@Component({
    selector: 'lex-reshard-case-index-dialog',
    templateUrl: './reshard-case-index-dialog.component.html',
    styleUrls: ['./reshard-case-index-dialog.component.scss'],
    standalone: false
})

export class ReshardCaseIndexDialogComponent extends BaseComponent {

	public selectedCase: LexbeCase;
	public currentShardCount: number;
	public currentShardSize: number;
	public reshardForm: UntypedFormGroup;

	constructor(
		private dialogRef: MatDialogRef<ReshardCaseIndexDialogComponent>,
		@Inject(MAT_DIALOG_DATA) private data: any,
		private formBuilder: UntypedFormBuilder,
		private caseManager: CaseManager) {
		super();
		this.selectedCase = this.data.selectedCase;
		this.currentShardCount = this.data.currentShardCount;
		this.currentShardSize = this.data.currentShardSize;
		this.reshardForm = this.formBuilder.group({
			primaryShard: [this.currentShardCount, [Validators.required, Validators.min(1), Validators.max(99)]]
		});
	}

	public start(): void {
		this.caseManager.putCaseShards(this.selectedCase.caseId, this.reshardForm.get('primaryShard').value).subscribe(() => this.dialogRef.close(true));
	}

}
